<template>
  <div>
    <div class="page">
      <div class="container px-11 2xl:px-3 mb-14 m-auto">
        <title-s-chapter
          :options="{
            from: 'from-resolution_blue',
            to: 'to-dodger_blue',
          }"
        >
          <h1 v-html="currentPage.content.pageTitle.text"></h1>
        </title-s-chapter>
        <p
          class="font-bold text-tundora text-xl mb-5"
          v-html="currentPage.content.pageSubTitle.text"
        ></p>

        <div class="container-components">
          <div class="card break-inside-avoid">
            <image-with-descriptions
              :options="{
                image:
                  'pages/' +
                  currentPage.slug +
                  '/' +
                  currentPage.images.image1.src,
                descriptions: [
                  {
                    text: currentPage.images.image1.edf,
                    position: 'bottom-right', // top/bottom-left/right
                    orientation: 'horizontal', // vertical, horizontal
                  },
                ],
              }"
            />
            <TitleParagraph
              :options="{
                from: 'from-resolution_blue',
                to: 'to-dodger_blue',
              }"
            >
              <span
                class="text-xl lg:text-2xl 2xl:text-4xl"
                v-html="currentPage.content.firstTitle.text"
              ></span>
            </TitleParagraph>

            <TitleParagraph
              :options="{
                from: 'from-resolution_blue',
                to: 'to-dodger_blue',
              }"
            >
              <Triangles
                :options="{
                  colors: ['#00357f', '#0b4f9c', '#0d94ff'],
                  direction: 'top',
                }"
              />
              <span v-html="currentPage.content.firstSubTitle.text"></span>
            </TitleParagraph>

            <paragraph
              :options="{
                color: 'text-nandor',
              }"
            >
              <span v-html="currentPage.content.firstParagraph.text"> </span>
            </paragraph>
          </div>

          <div class="card break-inside-avoid">
            <TitleParagraph
              :options="{
                from: 'from-resolution_blue',
                to: 'to-dodger_blue',
              }"
            >
              <span
                class="text-xl lg:text-2xl 2xl:text-4xl"
                v-html="currentPage.content.secondTitle.text"
              ></span>
            </TitleParagraph>

            <TitleParagraph
              :options="{
                from: 'from-resolution_blue',
                to: 'to-dodger_blue',
              }"
            >
              <Triangles
                :options="{
                  colors: ['#00357f', '#0b4f9c', '#0d94ff'],
                  direction: 'bottom',
                }"
              />
              <span v-html="currentPage.content.secondSubTitle.text"></span>
            </TitleParagraph>

            <paragraph
              :options="{
                color: 'text-nandor',
              }"
            >
              <span v-html="currentPage.content.secondParagraph.text"> </span>
            </paragraph>

            <div>
              <image-with-descriptions
                :options="{
                  image:
                    'pages/' +
                    currentPage.slug +
                    '/' +
                    currentPage.images.image2.src,
                  descriptions: [
                    {
                      text: currentPage.images.image2.edf,
                      position: 'bottom-right', // top/bottom-left/right
                      orientation: 'horizontal', // vertical, horizontal
                    },
                  ],
                }"
              />
            </div>
          </div>

          <div class="card break-inside-avoid">
            <div>
              <image-with-descriptions
                :options="{
                  image:
                    'pages/' +
                    currentPage.slug +
                    '/' +
                    currentPage.images.image3.src,
                  descriptions: [
                    {
                      text: currentPage.images.image3.edf,
                      position: 'bottom-right', // top/bottom-left/right
                      orientation: 'horizontal', // vertical, horizontal
                    },
                  ],
                }"
              />
            </div>

            <TitleParagraph
              :options="{
                from: 'from-resolution_blue',
                to: 'to-dodger_blue',
              }"
            >
              <span
                class="text-xl lg:text-2xl 2xl:text-4xl"
                v-html="currentPage.content.thirdTitle.text"
              ></span>
            </TitleParagraph>

            <TitleParagraph
              :options="{
                from: 'from-resolution_blue',
                to: 'to-dodger_blue',
              }"
            >
              <Triangles
                :options="{
                  colors: ['#00357f', '#0b4f9c', '#0d94ff'],
                  direction: 'top',
                }"
              />
              <span v-html="currentPage.content.thirdSubTitle.text"></span>
            </TitleParagraph>

            <paragraph
              :options="{
                color: 'text-nandor',
              }"
            >
              <span v-html="currentPage.content.thirdParagraph.text"> </span>
            </paragraph>
          </div>

          <div class="card break-inside-avoid">
            <TitleParagraph
              :options="{
                from: 'from-resolution_blue',
                to: 'to-dodger_blue',
              }"
            >
              <span v-html="currentPage.content.firthSubTitle.text"></span>
            </TitleParagraph>

            <paragraph
              :options="{
                color: 'text-nandor',
              }"
            >
              <span v-html="currentPage.content.fourthParagraph.text"> </span>
              <Triangles
                :options="{
                  colors: ['#00357f', '#0b4f9c', '#0d94ff'],
                  direction: 'bottom',
                }"
              />
            </paragraph>

            <div>
              <image-with-descriptions
                :options="{
                  image:
                    'pages/' +
                    currentPage.slug +
                    '/' +
                    currentPage.images.image4.src,
                  descriptions: [
                    {
                      text: currentPage.images.image4.edf,
                      position: 'bottom-right', // top/bottom-left/right
                      orientation: 'horizontal', // vertical, horizontal
                    },
                  ],
                }"
              />
            </div>
          </div>

          <div class="card break-inside-avoid">
            <div>
              <image-with-descriptions
                :options="{
                  image:
                    'pages/' +
                    currentPage.slug +
                    '/' +
                    currentPage.images.image5.src,
                  descriptions: [
                    {
                      text: currentPage.images.image5.edf,
                      position: 'bottom-right', // top/bottom-left/right
                      orientation: 'horizontal', // vertical, horizontal
                    },
                  ],
                }"
              />
            </div>

            <TitleParagraph
              :options="{
                from: 'from-resolution_blue',
                to: 'to-dodger_blue',
              }"
            >
              <Triangles
                :options="{
                  colors: ['#00357f', '#0b4f9c', '#0d94ff'],
                  direction: 'top',
                }"
              />
              <span v-html="currentPage.content.sixthSubTitle.text"></span>
            </TitleParagraph>

            <paragraph
              :options="{
                color: 'text-nandor',
              }"
            >
              <span v-html="currentPage.content.fifthParagraph.text"> </span>
              <!-- <square
                :options="{
                  from: 'from-resolution_blue',
                  to: 'to-dodger_blue',
                }"
              /> -->
            </paragraph>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PagesMixin from "@/mixins/PagesMixin";
import TitleSChapter from "../../components/TitleSChapter.vue";
import Triangles from "../../components/Triangles.vue";
import TitleParagraph from "../../components/TitleParagraph.vue";
import Paragraph from "../../components/Paragraph.vue";
import ImageWithDescriptions from "../../components/ImageWithDescriptions.vue";

export default {
  components: {
    TitleSChapter,
    Triangles,
    TitleParagraph,
    ImageWithDescriptions,
    Paragraph,
  },
  name : "PageTest",
  mixins: [PagesMixin],
};
</script>

<style scoped lang="scss">
.container-components .card {
  margin-bottom: 0;
}
</style>
